export const required = value => (value ? undefined : '此欄位為必填');

const nullValue = init => value => (value === init ? '請選擇正確的資料' : undefined)
export const nullValue1 = nullValue('-1');

const maxLength = max => value =>
    value && value.length > max ? `請勿超過 ${max} 字` : undefined;
export const maxLength15 = maxLength(15);
const minLength = min => value =>
    value && value.length < min ? `最少請輸入 ${min} 字` : undefined
export const minLength2 = minLength(2)


export const number = value =>
    value && isNaN(Number(value)) ? 'Must be a number' : undefined

const minValue = min => value =>
    value && value < min ? `Must be at least ${min}` : undefined
export const minValue18 = minValue(18)

export const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? '請輸入正確的格式 ex: aaa@gmail.com'
        : undefined

export const person_id = value =>
    value && !/^[A-Z]\d{9}$/i.test(value) && !/^[A-Z]{1,2}[0-9]{8}$/i.test(value)
        ? '請輸入正確的身分證字號'
        : undefined



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DeviseContainer/LoginContainer/validDesc.jsx